import { useCallback, useSyncExternalStore } from "react";

// In-memory only: retain drafts (including File objects) during wizard navigation.
const values = new Map();
const listeners = new Map();

export function useDiscussionState(key, initialValue) {
  const snapshot = useCallback(() => {
    if (!values.has(key)) values.set(key, typeof initialValue === "function" ? initialValue() : initialValue);
    return values.get(key);
  }, [key, initialValue]);
  const subscribe = useCallback((listener) => {
    if (!listeners.has(key)) listeners.set(key, new Set());
    listeners.get(key).add(listener);
    return () => {
      listeners.get(key)?.delete(listener);
      if (!listeners.get(key)?.size) listeners.delete(key);
    };
  }, [key]);
  const value = useSyncExternalStore(subscribe, snapshot, snapshot);
  const setValue = useCallback((next) => {
    const previous = values.has(key) ? values.get(key) : initialValue;
    values.set(key, typeof next === "function" ? next(previous) : next);
    listeners.get(key)?.forEach((listener) => listener());
  }, [key, initialValue]);
  return [value, setValue];
}
